import './entities/Workshop.js';
import './entities/WorkshopAppointment.js';
import './entities/WorkshopAttendance.js';
import './entities/WorkshopAttendanceCount.js';
import './entities/WorkshopTrainingAttendance.js';

import './api/createWorkshopRegistration.js';
import './api/createWorkshopRegistrationExternal.js';
import './api/getWorkshopAttendanceByAccessToken.js';
import './api/mutationWorkshopMigration.js';
import './api/mutationWorkshopMigrationOnboarding.js';
import './api/sendWorkshopParticipantsMail.js';
import './api/sendWorkshopRegistrationMail.js';
import './api/sendWorkshopStornoMail.js';
import './api/stornoWorkshopAttendanceByAccessToken.js';
import './api/subscribeWorkshopAllAttendanceSimple.js';
import './api/subscribeWorkshopAttendance.js';
import './api/subscribeWorkshopAttendanceCount.js';
import './api/subscribeWorkshopAttendanceSimple.js';
import './api/subscribeWorkshopOnboarding.js';
import './api/subscribeWorkshopTrainingAttendance.js';
import './api/subscribeWorkshopTrainingAttendanceSimple.js';
